import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';

const incident = (): Partial<GridColDef> => ({
  field: 'incident',
  headerName: 'Incident #',
  width: 150,
  renderCell: (params) => params.row.incident ?? '-',
  sortable: true,
});

const date = (): Partial<GridColDef> => ({
  field: 'date',
  headerName: 'Date and time',
  width: 200,
  renderCell: (params) => params.row.date ?? '-',
});

const type = (): Partial<GridColDef> => ({
  field: 'type',
  headerName: 'Type',
  width: 180,
  renderCell: (params) => params.row.type ?? '-',
});

const vehicle = (): Partial<GridColDef> => ({
  field: 'vehicle',
  headerName: 'Vehicle',
  width: 160,
  renderCell: (params) => {
    return `${params.row.licensePlate} - ${params.row.make} - ${params.row.model}`;
  },
  sortable: true,
});

const initiator = (): Partial<GridColDef> => ({
  field: 'initiator',
  headerName: 'Initiator',
  width: 160,
  renderCell: (params) => {
    return params.row.initiator;
  },
  sortable: true,
});

const company = (): Partial<GridColDef> => ({
  field: 'company',
  headerName: 'Company',
  width: 180,
  renderCell: (params) => params.row.company ?? '-',
});

const status = (): Partial<GridColDef> => ({
  field: 'status',
  headerName: 'Status',
  width: 180,
  renderCell: (params) => params.row.status ?? '-',
});

const actions = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  width: 100,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const towingRecords = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void,
) => {
  return {
    incident,
    date,
    type,
    vehicle,
    initiator,
    company,
    status,
    actions: () => actions(openMenu),
  };
};
